import { Banner } from "@/components/banner";
import { AsideBanner, DateSearchBar, Magazine, SpecialDetail, SpecialPreview } from "@/domains/components";
import { useBookingRecoilValue } from "@/shared/client";
import { type SpecialInfoResponse, useGetSpecial } from "@/shared/server";
import { Box, Center, Spinner, Text } from "@chakra-ui/react";
import { useParams } from "react-router-dom";

export const Specials = () => {
    const { specialIdx } = useParams<string>();
    const option = { enabled: !!specialIdx };

    const { data } = useGetSpecial<SpecialInfoResponse>({ specialIdx: specialIdx ?? "" }, option);
    const bookingEngine = useBookingRecoilValue();

    if (!specialIdx) {
        // 404로 요청
        return <div>404로 요청합니다</div>;
    }

    return data ? (
        <Box w="100%">
            <Box position="relative">
                <Banner imgList={data.imgList} catchPraise={data.catchPraise} />
                {!bookingEngine.isGoogleBE && <DateSearchBar isSubMenu />}
            </Box>
            <SpecialDetail specialIdx={specialIdx} />
            <Magazine idx={specialIdx} />
            <AsideBanner isFullImg={false} />
            <SpecialPreview title="SPECIAL PREVIEW" />
        </Box>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
